import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { CustomerPriorityComponent } from './customer-priority.component';
import { ColorCircleModule } from 'ngx-color/circle';

const routes: Routes = [
  { path: '', component: CustomerPriorityComponent, data: { title: 'Customer Priority' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes), ColorCircleModule],
  exports: [RouterModule],
})
export class CustomerPriorityRoutingModule {}

@NgModule({
  imports: [
    CustomerPriorityRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [CustomerPriorityComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [CustomerPriorityComponent],
})
export class CustomerPriorityModule {}
